import { numberFormatToPtBr } from '@/utils';

export const formatTooltip = (data) => {
  return `
    <div class="tooltip-matrix">
      <div class="tooltip-matrix__header">
        <span 
          class="tooltip-matrix__point" 
          style="background-color: ${data.color}"
        >
        </span>
        <h5 class="tooltip-matrix__name">
          ${data.point.name}
        </h5>
      </div>

      <ul>
        <li>
          <div class="tooltip-matrix__item">
            <span>Índice de engajamento</span>
            <span>${numberFormatToPtBr(data.y)}</span>
          </div>
        </li>

        <li>
          <div class="tooltip-matrix__item">
            <span>Índice de sentimento</span>
            <span>${data.x}</span>
          </div>
        </li>
      </ul>
    </div>
  `;
};
